<template>
  <div class="screen">
    <div class="content">
      <img src="../assets/imgs/screen_rotate.png" alt />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
.screen {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  //   background-image: url("../../public/images/screen.png");
  //   background-size: cover;
  background-color: #a1d6fe;
  z-index: 9999;
  display: none;
  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
@media screen and (orientation: landscape) {
  .screen {
    display: block;
  }
}
</style>